import React from "react";
import { Activity, Check, CircleMinus, Database } from "lucide-react";

const LABELS = { empty: "Waiting for text", word_floor: "Collecting words", word_spacing: "Waiting for new words",
  specific_enough: "Specific enough · no check needed", unchanged: "Unchanged", large_insert: "Chunk received",
  low_specificity: "Vague reference detected", specificity_drop: "Specificity dropped", explicit_detail: "New detail detected" };

export function GateStatus({ stats, loading, result, config }) {
  const measurement = stats.last;
  const changes = result?.memory_changes || [];
  const negative = Object.values(result?.metadata?.checks || {}).filter((c) => c.outcome === "no_match");
  return <div className="mt-3 border-t border-line pt-3 text-xs font-mono space-y-2" data-testid="gate-status">
    <div className="flex flex-wrap gap-2 items-center text-teal" data-testid="gate-decision" aria-live="polite">
      <Activity size={13} className={loading ? "animate-pulse" : ""} />
      {loading ? "Checking…" : LABELS[measurement?.rule_id] || "Automatic checks on"}
    </div>
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-muted">
      <span data-testid="gate-word-count">{measurement?.word_count || 0} words / {config.min_words} minimum</span>
      <span data-testid="gate-specificity">Specificity {measurement ? Math.round(measurement.specificity * 100) : "—"}%</span>
      <span data-testid="gate-drop">Drop {Math.round((measurement?.relative_drop || 0) * 100)}%</span>
      <span data-testid="gate-spacing">{measurement?.words_since_last_call || 0} changed / {config.min_words_between_calls} between checks</span>
      <span data-testid="gate-call-count">{stats.calls} checks</span>
      <span data-testid="gate-negative-count">{stats.negatives} no-match checks</span>
    </div>
    {result?.check && <div data-testid="check-outcome" className={result.check.outcome === "linked" ? "text-lime" : "text-muted"}>
      {result.check.outcome === "linked" ? "Confident links found" : "No match · later details can resolve this"}
    </div>}
    {negative.map((c, i) => <div className="text-muted flex gap-2" key={i} data-testid={`negative-reference-${i}`}>
      <CircleMinus size={13} className="shrink-0" /> “{c.text}” · no match yet
    </div>)}
    {changes.map((c, i) => <div key={i} data-testid={`memory-change-${i}`} className="flex items-start gap-2 text-lime">
      {c.action === "created" ? <Database size={13} className="shrink-0" /> : <Check size={13} className="shrink-0" />}
      {c.action === "created" ? "Saved to palace: " : "Kept existing pointer: "}{c.canonical}
    </div>)}
  </div>;
}